import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import qs from "qs";
import { SendQrDTO } from "./models";
import { DefaultResponse } from "shared/types/general";

export const VisitBonusApi = async (dto: SendQrDTO) => {
  const { data } = await api.post<DefaultResponse>(
    API_ROUTES.VISIT_BONUS,
    qs.stringify({ ...defaultOptions(), ...dto })
  );

  return data;
};
